import Vue from "vue";
import moment from "moment";
import * as $ from "jquery";
import Component from "vue-class-component";
import { KeyValue } from "../../../../shared/models/Input";
import { ServicesFactoryInstance } from "../../../Controls/ServicesFactory";
import { ContratSalarieNameDto } from "../../../../dto/GenApi.iNotPaie.Dto/ContratSalarieNameDto";
import { ParametresInstance } from "../../../Controls/Parameters";

@Component
export default class ModalAjoutContratAmorcageTauxPAS extends Vue {
	
	public listeContrats: ContratSalarieNameDto[] = [];
	
	public dataReady = true;

	public currentIdContrat = "0";

	// ------------------------------------------------------------
	
	public init(): void {
		this.dataReady = false;
		this.listeContrats = [];
		this.currentIdContrat = "0";
		const periodeActive = ParametresInstance.societeCourante?.PeriodeActive;
		// Récupération de la liste des salariés actifs sur la période en cours.
		if (periodeActive) {
			ServicesFactoryInstance.SalarieService.GetContratsActifs((data: ContratSalarieNameDto[]) => {
				this.listeContrats = data;
				this.dataReady = true;
			}, () => {
				this.dataReady = true;
			});
		} else {
			this.dataReady = true;
		}
	}

	public submit(): void {
		this.$emit("addContrat", parseInt(this.currentIdContrat));
		$("#modalAjoutContratAmorcageTauxPAS").modal("hide");
	}

	public cancel(): void {
		$("#modalAjoutContratAmorcageTauxPAS").modal("hide");
	}

	public transformList(list: ContratSalarieNameDto[]): KeyValue[] {
		const finalList: KeyValue[] = [];

		for (let i = 0; i < list.length; i++) {
			finalList.push({
				key: list[i].IdContrat.toString(),
				value: `${list[i].NomSalarie} ${list[i].PrenomSalarie} (Contrat N°${list[i].NumeroContrat})`
			});
		}

		return finalList;
	}
}



// WEBPACK FOOTER //
// ./src/components/dsn/tableAmorcageTauxPAS/modalAjoutContratAmorcageTauxPAS/modalAjoutContratAmorcageTauxPAS.ts